import { z } from 'zod'

export const publicEnvSchema = z.object({
  VITE_API_HOST: z.string(),
  VITE_AUTH0_DOMAIN: z.string(),
  VITE_AUTH0_SPA_APP_CLIENT_ID: z.string(),
  VITE_BUGSNAG_API_KEY: z.string().optional(),
  VITE_MANAGER_CLIENT_URL: z.string().optional(),
  VITE_POSTHOG_API_KEY: z.string().optional(),
  VITE_POSTHOG_API_URL: z.string().optional(),
})
